module.exports = __webpack_public_path__ + "static/media/yellow_dots.d46488df.svg";